import moment from 'moment';

export const PTW_OPTION_STATUS = {
    'New': ['Submitted'],
    'Submitted': ['Pending Approval', 'No Activity', 'Rejected', 'Closed'],
    'Pending Approval': ['Approved', 'Rejected', 'Closed'],
    'Approved': ['Rejected', 'Closed'],
    'No Activity': ['Submitted'],
};

export const APPROVER_STATUS = ['Approved', 'Rejected'];

export function getNextStatusOptions(jobStatus, item, isOnlyApprover = false) {
    let options = PTW_OPTION_STATUS[jobStatus] || [];
    if(item && item.status && ['Approved'].includes(item.status)) {
        let today = moment().format("YYYY-MM-DD");
        if(item.expiry_date && moment(today).isAfter(moment(item.expiry_date).format("YYYY-MM-DD"))) {
            options = ['Closed'];
        }
    }
    if(isOnlyApprover) {
        options = options.filter(status => APPROVER_STATUS.includes(status));
    }
    return options;
}
